import React, { useState } from 'react';
import {
  Box, Typography, Table, TableHead, TableRow, TableCell, TableBody,
  Paper, TableContainer
} from '@mui/material';
import DateRangeFilter, { defaultStart, defaultEnd } from '../Reports/DateRangeFilter';
import { GetAuditLog } from '../../../api';
import dayjs from 'dayjs';

const AuditLog = ({ access }) => {
  const [start, setStart] = useState(defaultStart());
  const [end, setEnd] = useState(defaultEnd());
  const [rows, setRows] = useState([]);

  const run = () =>
    GetAuditLog(access?.org?.id, { start, end }).then(setRows).catch(() => {});

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>Audit Log</Typography>
      <DateRangeFilter start={start} end={end} onStart={setStart} onEnd={setEnd} onSubmit={run} />
      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Date / Time</TableCell>
              <TableCell>User</TableCell>
              <TableCell>IP</TableCell>
              <TableCell>Event</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map(r => (
              <TableRow key={r.id}>
                <TableCell>{dayjs(r.timestamp).format('MM/DD/YY h:mm:ss A')}</TableCell>
                <TableCell>{r.actor?.name || r.actor?.email || '—'}</TableCell>
                <TableCell>{r.ip || '—'}</TableCell>
                <TableCell>{r.action}</TableCell>
              </TableRow>
            ))}
            {!rows.length && <TableRow><TableCell colSpan={4} align="center">No events</TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default AuditLog;
